import React from "react";
import {TextButton} from "js/common/views/inputs/buttons";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const LeaveUnsavedChangesDialog = ({onStay, onLeave}) => {
  const {theme} = React.useContext(CustomThemeContext);

  return (
      <div style={{padding: "0.5rem 0", overflow: "hidden", textAlign: "center"}}>
        <i
            className="bhi-caution-circle"
            style={{fontSize: 58, lineHeight: 1, display: "inline-block", color: theme.palette.warning.main}} />

        <p style={{marginTop: "0.75rem", padding: "0 1rem"}}>
          <strong style={{fontSize: "1.2rem", fontWeight: 600}}>Unsaved Changes</strong><br />
          <span style={{fontSize: "0.9rem"}}>Are you sure you want to discard your changes to this dashboard?</span>
        </p>

        <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <TextButton
              key="leave-unsaved-stay"
              testId="leave-unsaved-stay-button"
              style={{marginRight: "1rem", marginLeft: "0.5rem", backgroundColor: theme.palette.background.paper}}
              label="Stay"
              onClick={onStay}
          />
          <TextButton
              key="leave-unsaved-leave"
              type="alert"
              testId="leave-unsaved-leave-button"
              label="Leave"
              style={{marginLeft: "0.5rem", color: theme.palette.text.inverted, marginRight: "0.5rem"}}
              onClick={onLeave}
          />
        </div>
      </div>
  );
};

export default LeaveUnsavedChangesDialog;
